"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.markUpdate = exports.updateTimingStart = exports.setUpdatePerformanceEnabled = exports.mark = exports.reset = void 0;
var imports_1 = require("../lib/imports");
var t0 = 0;
var reset = function (label) {
    if (label === void 0) { label = ''; }
    t0 = performance.now();
    if (label) {
        exports.mark(label);
    }
};
exports.reset = reset;
var mark = function (label, reportIfOver) {
    if (reportIfOver === void 0) { reportIfOver = 0.25; }
    var t1 = performance.now();
    var elapsed = t1 - t0;
    t0 = t1;
    if (elapsed > reportIfOver) {
        console.log('perf|', elapsed.toFixed(1) + ' ms' + '|', label);
    }
};
exports.mark = mark;
exports.reset('init');
var update_t0 = 0;
var update_tlast = 0;
var updateFrames = 0;
var pieParts = {};
var updatePerformanceEnabled = false;
var setUpdatePerformanceEnabled = function (isEnabled) {
    if (isEnabled && !updatePerformanceEnabled) {
        console.log('begin performance logging');
        updateTimingReset();
    }
    if (!isEnabled && updatePerformanceEnabled) {
        console.log('end performance logging');
        reportUpdateTimings();
    }
    updatePerformanceEnabled = isEnabled;
};
exports.setUpdatePerformanceEnabled = setUpdatePerformanceEnabled;
var updateTimingReset = function () {
    update_t0 = performance.now();
    update_tlast = update_t0;
    pieParts = {};
    updateFrames = 0;
};
var updateTimingStart = function () {
    update_t0 = performance.now();
    update_tlast = update_t0;
    updateFrames++;
};
exports.updateTimingStart = updateTimingStart;
var markUpdate = function (label) {
    if (updatePerformanceEnabled) {
        var t1 = performance.now();
        var elapsed = t1 - update_tlast;
        update_tlast = t1;
        // assert.nil(pieParts[label])
        var existing = pieParts[label];
        if (existing) {
            existing.elapsed += elapsed;
        }
        else {
            pieParts[label] = { label: label, elapsed: elapsed };
        }
    }
    // console.log('perf_update|', elapsed + ' ms' + '|', label)
};
exports.markUpdate = markUpdate;
var reportUpdateTimings = function () {
    var parts = imports_1.l.reverse(imports_1.l.sortBy(pieParts, 'elapsed'));
    var parts2 = imports_1.l.take(parts, 10);
    var parts3 = imports_1.l.map(parts2, function (c) { return ({
        label: c.label,
        ms: c.elapsed,
    }); });
    imports_1.l.forEach(parts3, function (c, cIdx) {
        console.log('perf|', 'report|', cIdx + 1, c.label, '|', c.ms.toFixed(1), '|', (c.ms / updateFrames).toFixed(2));
    });
    console.log('perf|', 'report|', updateFrames, 'frames');
};
